

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "1",
    itemName: "Esprit Shirt",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-01.jpg.webp",
    description: "A premium quality and stylish T-shirt for men.",
    rating: 4.5,
    reviews: 10,
    size: "L",
    category: "Women",
    oldPrice: 790.99,
    newPrice: 590.99,
    discount: 25,
    isTrending: true,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: true,

  },
  {
    _id: "2",
    itemName: "Check Trouser",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-03.jpg.webp",
    description: "A cozy and warm hoodie for kids.",
    rating: 4.7,
    reviews: 8,
    size: "S",
    category: "Men",
    oldPrice: 490.99,
    newPrice: 390.99,
    discount: 20,
    isTrending: true,
    inStock: false,
    delivery_time: "2-4 business days",
    fewLeft: false
  },
  {
    _id: "3",
    itemName: "Herschel supply",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-02.jpg.webp",
    description: "An elegant and fashionable dress for women.",
    rating: 3.2,
    reviews: 5,
    size: "M",
    category: "Women",
    oldPrice: 1290.99,
    newPrice: 990.99,
    discount: 23,
    isTrending: false,
    inStock: true,
    delivery_time: "3-5 business days",
    fewLeft: true,
  },
  
  {
    _id: "4",
    itemName: "Classic Coat",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-04.jpg.webp",
    description: "A stylish and durable jacket for men.",
    rating: 2.2,
    reviews: 12,
    size: "XL",
    category: "Women",
    oldPrice: 1490.99,
    newPrice: 1190.99,
    discount: 20,
    isTrending: false,
    inStock: true,
    delivery_time: "4-6 business days",
    fewLeft: true,
  },
  {
    _id: "5",
    itemName: "Front Jumper",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-05.jpg.webp",
    description: "A comfortable and trendy pair of jeans for women.",
    rating: 4.8,
    reviews: 15,
    size: "M",
    category: "Women",
    oldPrice: 890.99,
    newPrice: 690.99,
    discount: 22,
    isTrending: true,
    inStock: true,
    delivery_time: "3-5 business days",
    fewLeft: false
  },
  {
    _id: "6",
    itemName: "Vintage Watch",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-06.jpg.webp",
    description: "A classic and formal shirt for men.",
    rating: 1.9,
    reviews: 6,
    size: "L",
    category: "Accessories",
    oldPrice: 990.99,
    newPrice: 790.99,
    discount: 20,
    isTrending: true,
    inStock: false,
    delivery_time: "2-4 business days",
    fewLeft: false
  },
  {
    _id: "7",
    itemName: "Shirt Cotton",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-07.jpg.webp",
    description: "A cozy and stylish sweater for women.",
    rating: 3.1,
    reviews: 9,
    size: "S",
    category: "Women",
    oldPrice: 690.99,
    newPrice: 490.99,
    discount: 29,
    isTrending: false,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: false
  },
  {
    _id: "8",
    itemName: "Pieces Printed",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-08.jpg.webp",
    description: "Comfortable and breathable shorts for men.",
    rating: 4.6,
    reviews: 11,
    size: "M",
    category: "Women",
    oldPrice: 590.99,
    newPrice: 390.99,
    discount: 33,
    isTrending: true,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: true,
  },
  {
    _id: "9",
    itemName: "Converse shoes",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-09.jpg.webp",
    description: "A stylish and elegant blouse for women.",
    rating: 3.8,
    reviews: 7,
    size: "XL",
    category: "Accessories",
    oldPrice: 690.99,
    newPrice: 590.99,
    discount: 20,
    isTrending: false,
    inStock: true,
    delivery_time: "3-5 business days",
    fewLeft: true,
  },
  {
    _id: "10",
    itemName: "Femme T-Shirt ",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-10.jpg.webp",
    description: "Stylish and comfortable pants for men.",
    rating: 4.4,
    reviews: 14,
    size: "L",
    category: "Women",
    oldPrice: 790.99,
    newPrice: 590.99,
    discount: 25,
    isTrending: true,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: false
  },
  {
    _id: "11",
    itemName: "Herschel supply",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-11.jpg.webp",
    description: "A fashionable and versatile skirt for women.",
    rating: 4.2,
    reviews: 13,
    size: "M",
    category: "Men",
    oldPrice: 690.99,
    newPrice: 490.99,
    discount: 29,
    isTrending: false,
    inStock: true,
    delivery_time: "3-5 business days",
    fewLeft: false
  },
  {
    _id: "12",
    itemName: "H&M Leather Belt ",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-12.jpg.webp",
    description: "A comfortable and stylish T-shirt for kids.",
    rating: 2.9,
    reviews: 8,
    size: "S",
    category: "Accessories",
    oldPrice: 690.99,
    newPrice: 490.99,
    discount: 33,
    isTrending: true,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: true,
  },
  {
    _id: "13",
    itemName: "hoodie",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-14.jpg.webp",
    description: "A warm and trendy hoodie for men.",
    rating:4,
    reviews: 11,
    size: "L",
    category: "Women",
    oldPrice: 890.99,
    newPrice: 690.99,
    discount: 22,
    isTrending: true,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: false
  },
  {
    _id: "14",
    itemName: "Dennis Lingo Watch",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-15.jpg.webp",
    description: "A stylish and versatile jacket for women.",
    rating: 3.7,
    reviews: 15,
    size: "L",
    category: "Accessories",
    oldPrice: 1490.99,
    newPrice: 1190.99,
    discount: 20,
    isTrending: false,
    inStock: true,
    delivery_time: "3-5 business days",
    fewLeft: false
  },
  {
    _id: "15",
    itemName: "H&M shirt",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-16.jpg.webp",
    description: "A classic and formal shirt for men.",
    rating: 4.1,
    reviews: 9,
    size: "XXL",
    category: "Women",
    oldPrice: 990.99,
    newPrice: 790.99,
    discount: 20,
    isTrending: true,
    inStock: false,
    delivery_time: "2-4 business days",
    fewLeft: true,
  },
  {
    _id: "16",
    itemName: "Leather Backpack",
    image: "https://preview.colorlib.com/theme/cozastore/images/banner-06.jpg.webp",
    description: "A spacious and durable leather backpack for everyday use.",
    rating: 4.5,
    reviews: 12,
    size: "XXL",
    color: "Brown",
    category: "Accessories",
    oldPrice: 1590.99,
    newPrice: 1290.99,
    discount: 19,
    isTrending: true,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: false,
    }
    ,
    {
    _id: "17",
    itemName: "Plan cap ",
    image: "https://preview.colorlib.com/theme/cozastore/images/banner-03.jpg.webp",
    description: "High-quality wireless headphones with noise cancellation feature.",
    rating: 4.2,
    reviews: 18,
    color: "Black",
    size: "M",
    category: "Accessories",
    oldPrice: 990.99,
    newPrice: 890.99,
    discount: 23,
    isTrending: true,
    inStock: true,
    delivery_time: "1-3 business days",
    fewLeft: true,
    }
    ,
    {
    _id: "18",
    itemName: "Denim Jacket",
    image: "https://preview.colorlib.com/theme/cozastore/images/gallery-06.jpg.webp",
    description: "A trendy denim jacket for a cool and casual look.",
    rating: 3.7,
    reviews: 9,
    size: "M",
    category: "Women",
    oldPrice: 89.99,
    newPrice: 69.99,
    discount: 22,
    isTrending: true,
    inStock: true,
    delivery_time: "2-5 business days",
    fewLeft: true,
    }
    ,
    {
    _id: "19",
    itemName: "Sports shoes",
    image: "https://preview.colorlib.com/theme/cozastore/images/gallery-08.jpg.webp",
    description: "A sleek and durable sports watch with multiple functions.",
    rating: 4.0,
    reviews: 6,
    color: "Silver",
    category: "Accessories",
    size: "M",
    oldPrice: 790.99,
    newPrice: 690.99,
    discount: 25,
    isTrending: false,
    inStock: true,
    delivery_time: "3-6 business days",
    fewLeft: false,
    }
    ,
    {
    _id: "20",
    itemName: "Cotton Shirt",
    image: "https://preview.colorlib.com/theme/cozastore/images/product-detail-03.jpg.webp",
    description: "A comfortable and breathable cotton shirt for everyday wear.",
    rating: 3.3,
    reviews: 15,
    color: "White",
    category: "Women",
    size: "M",
    oldPrice: 29.99,
    newPrice: 19.99,
    discount: 33,
    isTrending: true,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: true,
    },
    {
      _id: "21",
      itemName: "Lether Jacket",
      image: "https://preview.colorlib.com/theme/cozastore/images/gallery-04.jpg.webp",
      description: "A stylish and comfortable cotton t-shirt for casual wear.",
      rating: 4.7,
      reviews: 27,
      color: "Black",
      category: "Men",
      size: "L",
      oldPrice: 34.99,
      newPrice: 24.99,
      discount: 28,
      isTrending: true,
      inStock: true,
      delivery_time: "2-4 business days",
      fewLeft: false
  },{
    _id: "22",
    itemName: "V-Neck T-Shirt",
    image: "https://preview.colorlib.com/theme/cozastore/images/slide-07.jpg.webp",
    description: "A classic V-neck cotton t-shirt for a stylish and casual look.",
    rating: 2.2,
    reviews: 12,
    color: "Navy Blue",
    category: "Men",
    oldPrice: 27.99,
    size: "M",
    newPrice: 19.99,
    discount: 29,
    isTrending: false,
    inStock: true,
    delivery_time: "2-4 business days",
    fewLeft: true
},{
  _id: "23",
  itemName: "Striped T-Shirt",
  image: "https://preview.colorlib.com/theme/cozastore/images/slide-06.jpg.webp",
  description: "A trendy striped cotton t-shirt for a chic and casual style.",
  rating: 3.5,
  reviews: 20,
  color: "Red/White",
  category: "Men",
  oldPrice: 31.99,
  size: "XL",
  newPrice: 24.99,
  discount: 22,
  isTrending: true,
  inStock: true,
  delivery_time: "2-4 business days",
  fewLeft: true
},
{
  _id: "24",
  itemName: "Cotton Polo Shirt",
  image: "https://preview.colorlib.com/theme/cozastore/images/slide-02.jpg.webp",
  description: "A classic and comfortable cotton polo shirt for a smart-casual look.",
  rating: 4.6,
  reviews: 18,
  color: "Men",
  category: "Men",
  size: "XXL",
  oldPrice: 39.99,
  newPrice: 29.99,
  discount: 25,
  isTrending: true,
  inStock: true,
  delivery_time: "2-4 business days",
  fewLeft: false
},{
  _id: "25",
  itemName: "Cotton T-Shirt",
  image: "https://preview.colorlib.com/theme/cozastore/images/product-detail-01.jpg.webp",
  description: "A trendy graphic print cotton t-shirt for a unique and stylish look.",
  rating: 2.8,
  reviews: 25,
  color: "Gray",
  category: "Men",
  size: "XXL",
  oldPrice: 32.99,
  newPrice: 24.99,
  discount: 24,
  isTrending: true,
  inStock: true,
  delivery_time: "2-4 business days",
  fewLeft: true
}


  
];

